import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { links } from '@repo/constants';
import { DiscordIcon } from '@repo/custom-icons';
import { Button } from '@repo/ui-primitives/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '@repo/ui-primitives/dropdown-menu';
import { FileText, Mail, MessageCircleQuestionMark, MessagesSquare } from 'lucide-react';
import { useEffect, useState } from 'react';
import { KeyboardShortcutsModal } from './keyboard-shortcuts-modal';
export function HeaderHelpMenu() {
    const [isKeyboardShortcutsOpen, setIsKeyboardShortcutsOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(()=>{
        const handleKeyDown = (event)=>{
            const activeElement = document.activeElement;
            const isInputFocused = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT' || activeElement.getAttribute('contenteditable') === 'true');
            if (!isInputFocused && event.key === '?') {
                event.preventDefault();
                setIsKeyboardShortcutsOpen(true);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(DropdownMenu, {
                open: isOpen,
                onOpenChange: setIsOpen,
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                        asChild: true,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "secondary",
                            className: "cursor-pointer rounded-full outline-none bg-input/70 hover:bg-input/80 ".concat(isOpen ? 'ring-2 ring-input' : ''),
                            size: "icon",
                            children: /*#__PURE__*/ _jsx(MessageCircleQuestionMark, {})
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuContent, {
                        side: "bottom",
                        align: "end",
                        sideOffset: 12,
                        className: "w-64 text-gray-25 border-border",
                        children: /*#__PURE__*/ _jsxs(DropdownMenuGroup, {
                            children: [
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        className: "cursor-pointer",
                                        href: links.doc,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-8",
                                                children: /*#__PURE__*/ _jsx(FileText, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Docs"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "Browse our documentation for setup guides, references, and best practices."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        id: "intercom-launcher",
                                        className: "cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-8",
                                                children: /*#__PURE__*/ _jsx(MessagesSquare, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Send us a message"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "We'll get back to you as soon as possible."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        className: "cursor-pointer",
                                        href: links.support,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-8",
                                                children: /*#__PURE__*/ _jsx(Mail, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Email us"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "Get in touch with our support team for assistance.Get in touch via email — we’ll follow up shortly"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                                    asChild: true,
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        className: "cursor-pointer",
                                        href: links.discord,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mb-8",
                                                children: /*#__PURE__*/ _jsx(DiscordIcon, {})
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Discord"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-xs text-muted-foreground",
                                                        children: "Ask questions, share feedback, and connect with other Zephyr Cloud users."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(KeyboardShortcutsModal, {
                isOpen: isKeyboardShortcutsOpen,
                onClose: ()=>{
                    setIsKeyboardShortcutsOpen(false);
                }
            })
        ]
    });
}
